/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatePaymentResponse = {
    transactionId?: string;
    portalUrl?: string;
    shortUrl?: string;
    expires?: string;
    state?: CreatePaymentResponse.state;
};
export namespace CreatePaymentResponse {
    export enum state {
        INITIATED = 'INITIATED',
        CONFIRMED = 'CONFIRMED',
        FAILED = 'FAILED',
    }
}

